// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"377":"98ab0197","827":"9bc6fb17"}[chunkId] + ".css";
};